import { Box } from "@mui/material";

const PageContent = ({ children }: { children: React.ReactNode }) => {
    return (
        <Box sx={{ minHeight: 'calc(100vh - 59px - 32px)'}} >
            {children}
        </Box>
    );
}

export default PageContent;
